import { Box, Card, Divider, Typography } from '@material-ui/core';
import React, { FC, useEffect, useState } from 'react';
import {
  ImageInput,
  ImageField,
  TextInput,
  required,
  ValidationErrorMessage,
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import { Raffle } from '../../types/raffle';
import {
  aboutTextAreaValidate,
  removeTags,
} from '../../helpers/inputsValidate';
import { OverviewContainer } from './shared/overview/OverviewContainer';
import { Overview } from './shared/overview/OverviewBlock';

interface Props {
  title: string;
  isShow: boolean;
  setAddress: (address: string) => void;
  record: Raffle | undefined;
  properties: Array<Overview>;
  setProperties: (properties: Array<Overview>) => void;
  overviewError: boolean;
}

const DreamHomeDescription: FC<Props> = (props) => {
  const validateRequired = [required()];
  const [bedroomText, setBedroomText] = useState(0);
  const [bathroomText, setBathroomText] = useState(0);
  const [outspace, setOutspace] = useState(0);
  const [about, setAbout] = useState(0);
  const [general, setGeneral] = useState(0);
  const [heading, setHeading] = useState(0);

  useEffect(() => {
    if (
      props.record &&
      Object.keys(props.record).length !== 0 &&
      typeof props.record.property !== 'string'
    ) {
      setBedroomText(removeTags(props.record.property.bedroomText).length);
      setBathroomText(removeTags(props.record.property.bathroomText).length);
      setOutspace(removeTags(props.record.property.outspaceText).length);
      setAbout(removeTags(props.record.property.description).length);
      setGeneral(removeTags(props.record.property.generalText).length);
      setHeading(removeTags(props.record.property.heading).length);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const bedroomCounter = (e: string) => {
    e = removeTags(e);
    const count = e.length === 0 ? 0 : e.length;
    setBedroomText(count);
  };

  const bathroomCounter = (e: string) => {
    e = removeTags(e);
    const count = e.length === 0 ? 0 : e.length;
    setBathroomText(count);
  };

  const outspaceCounter = (e: string) => {
    e = removeTags(e);
    const count = e.length === 0 ? 0 : e.length;
    setOutspace(count);
  };

  const generalCounter = (e: string) => {
    e = removeTags(e);
    const count = e.length === 0 ? 0 : e.length;
    setGeneral(count);
  };

  const headingCounter = (e: string) => {
    e = removeTags(e);
    const count = e.length === 0 ? 0 : e.length;
    setHeading(count);
  };

  const aboutCounter = (e: string) => {
    e = removeTags(e);
    const count = e.length === 0 ? 0 : e.length;
    setAbout(count);
  };

  const textAreaValidateLength = (value: string) => {
    const errors: ValidationErrorMessage = {
      message: '',
      args: { message: '' },
    };
    if (!value) {
      return (errors.message = 'Required');
    }
    if (removeTags(value).length > 500) {
      return (errors.message = 'Must be 500 characters or less');
    }
    return undefined;
  };

  return (
    <>
      <Box display={{ md: 'block', lg: 'flex' }} justifyContent='space-between'>
        <Box width={{ md: '100%', lg: '70%' }} marginTop='2em'>
          <Card className='description-general'>
            <Box padding='2em'>
              <Typography variant='h6' gutterBottom className='base-color'>
                Features
              </Typography>
              <hr />
              <Box>
                <ImageInput
                  source='property.filesCard'
                  label='Dreamhome Card'
                  multiple={false}
                  className='base-color image-field'
                  // validate={validateRequired}
                  disabled={props.isShow}
                >
                  <ImageField source='src' title='title' />
                </ImageInput>
              </Box>
              <Box>
                <ImageInput
                  source='property.filesMobileCard'
                  label='Dreamhome Mobile Card'
                  multiple={false}
                  className='base-color image-field'
                  // validate={validateRequired}
                  disabled={props.isShow}
                >
                  <ImageField source='src' title='title' />
                </ImageInput>
              </Box>
              {/* <Box display='flex' position='relative' className='text-parent'>
                <RichTextInput
                  onChange={bedroomCounter}
                  className='rich-text'
                  source='property.bedroomText'
                  label='Bedrooms *'
                  validate={textAreaValidateLength}
                  disabled={props.isShow}
                />
                <div
                  className={
                    bedroomText === 0
                      ? 'text-placeholder'
                      : 'text-placeholder-fill'
                  }
                >
                  Add a description
                </div>
                <div className='text-counter'>{bedroomText}/500</div>
                <Box padding='4em'></Box>
                <ImageInput
                  source='property.filesBedroom'
                  label='Add Images'
                  multiple={false}
                  className='base-color image-field'
                  validate={validateRequired}
                  disabled={props.isShow}
                >
                  <ImageField source='src' title='title' />
                </ImageInput>
              </Box> */}
              <Divider id='divider' />
              {/* <Box display='flex' position='relative' className='text-parent'>
                <RichTextInput
                  onChange={bathroomCounter}
                  className='input-form'
                  source='property.bathroomText'
                  label='Bathrooms *'
                  validate={textAreaValidateLength}
                  disabled={props.isShow}
                />
                <div
                  className={
                    bathroomText === 0
                      ? 'text-placeholder'
                      : 'text-placeholder-fill'
                  }
                >
                  Add a description
                </div>
                <div className='text-counter'>{bathroomText}/500</div>
                <Box padding='4em'></Box>
                <ImageInput
                  source='property.filesBathroom'
                  label='Add Images'
                  multiple={false}
                  className='base-color image-field'
                  validate={validateRequired}
                  disabled={props.isShow}
                >
                  <ImageField source='src' title='title' />
                </ImageInput>
              </Box> */}

              <Divider id='divider' />

              {/* <Box display='flex' position='relative' className='text-parent'>
                <RichTextInput
                  onChange={outspaceCounter}
                  className='input-form'
                  source='property.outspaceText'
                  label='Outspace *'
                  validate={textAreaValidateLength}
                  disabled={props.isShow}
                />
                <div
                  className={
                    outspace === 0
                      ? 'text-placeholder'
                      : 'text-placeholder-fill'
                  }
                >
                  Add a description
                </div>
                <div className='text-counter'>{outspace}/500</div>
                <Box padding='4em'></Box>
                <ImageInput
                  source='property.filesOutspace'
                  label='Add Images'
                  multiple={false}
                  className='base-color image-field'
                  validate={validateRequired}
                  disabled={props.isShow}
                >
                  <ImageField source='src' title='title' />
                </ImageInput>
              </Box> */}

              <Box className='about-section text-parent' position='relative'>
                <RichTextInput
                  onChange={aboutCounter}
                  className='input-form'
                  source='property.description'
                  label='About *'
                  data={1000}
                  validate={aboutTextAreaValidate}
                  disabled={props.isShow}
                />
                <div
                  className={
                    about === 0 ? 'text-placeholder' : 'text-placeholder-fill'
                  }
                >
                  Add a description
                </div>
                <div className='about-text-counter'>{about}/1000</div>
              </Box>

              {/* <Box className='about-section text-parent' position='relative'>
                <RichTextInput
                  onChange={generalCounter}
                  className='input-form'
                  source='property.generalText'
                  label='Product Page CTA *'
                  data={100}
                  // validate={aboutTextAreaValidate}
                  disabled={props.isShow}
                />
                <div
                  className={
                    about === 0 ? 'text-placeholder' : 'text-placeholder-fill'
                  }
                >
                  Add a description
                </div>
                <div className='about-text-counter'>{general}/100</div>
              </Box> */}

              {/* <Box className='about-section text-parent' position='relative'>
                <RichTextInput
                  onChange={headingCounter}
                  className='input-form'
                  source='property.heading'
                  label='Heading 1 *'
                  data={500}
                  // validate={aboutTextAreaValidate}
                  disabled={props.isShow}
                />
                <div
                  className={
                    about === 0 ? 'text-placeholder' : 'text-placeholder-fill'
                  }
                >
                  Add a description
                </div>
                <div className='about-text-counter'>{heading}/500</div>
              </Box> */}
            </Box>
          </Card>
        </Box>
        <Box width={{ md: '100%', lg: '28%' }} marginTop='2em'>
          <Card>
            <Box padding='2em'>
              <Typography variant='h6' gutterBottom className='base-color'>
                Floor Plan
              </Typography>
              <hr />
              <ImageInput
                source='property.filesFloorPlan'
                label='Add Images'
                multiple={false}
                className='base-color image-field'
                // validate={validateRequired}
                disabled={props.isShow}
              >
                <ImageField source='src' title='title' />
              </ImageInput>
            </Box>
          </Card>
          <Box marginTop='2em'>
            <Card>
              <Box padding='2em'>
                <Typography variant='h6' gutterBottom className='base-color'>
                  Location Map
                </Typography>
                <hr />
                <ImageInput
                  source='property.filesMapImage'
                  label='Add Images'
                  multiple={false}
                  className='base-color image-field'
                  // validate={validateRequired}
                  disabled={props.isShow}
                >
                  <ImageField source='src' title='title' />
                </ImageInput>
              </Box>
            </Card>
          </Box>
          {/* <Box marginTop='2em'>
            <Card>
              <Box padding='2em'>
                <Typography variant='h6' gutterBottom className='base-color'>
                  Take a Tour with Sara
                </Typography>
                <hr />
                <TextInput
                  disabled={props.isShow}
                  source='property.tourLink'
                  fullWidth
                  className='input-form'
                  label='Add link'
                  validate={
                    props.title && props.title === 'london'
                      ? validateRequired
                      : undefined
                  }
                />
              </Box>
            </Card>
          </Box>

          <Box marginTop='2em'>
            <Card>
              <Box padding='2em'>
                <Typography variant='h6' gutterBottom className='base-color'>
                  3D Tour
                </Typography>
                <hr />
                <TextInput
                  source='property.pixangleSource'
                  disabled={props.isShow}
                  fullWidth
                  className='input-form'
                  label='Add link'
                  validate={
                    props.title && props.title === 'london'
                      ? validateRequired
                      : undefined
                  }
                />
              </Box>
            </Card>
          </Box> */}
          {/* <Box marginTop='2em'>
            <Card>
              <OverviewContainer
                properties={props.properties}
                setProperties={props.setProperties}
                overviewError={props.overviewError}
              />
            </Card>
          </Box> */}
        </Box>
      </Box>
    </>
  );
};

export default DreamHomeDescription;
